import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import * as FileSaver from 'file-saver';


import { AdministracionService } from '../administracion.service';
import { PerfilModel } from 'src/app/modelo/Perfil.model';
import { TareaModel } from 'src/app/modelo/Tarea.model';
import { EliminarData } from 'src/app/modelo/EliminarData';
import { PerfilTareaDataModel } from 'src/app/modelo/PerfilTareaData.model';
import { User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { FAZILService } from 'src/app/core/services/fazil.service';

@Component({
    selector: 'app-admin-perfiles',
    templateUrl: './admin-perfiles.component.html',
    styleUrls: ['./admin-perfiles.component.scss']
})
export class AdminPerfilesComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    perfiles: PerfilModel[] = [];
    perfilesSeleccionados: PerfilModel[];
    perfil: PerfilModel = new PerfilModel();
    tareasNoAsignadas: TareaModel[] = []; //Lista de tareas disponibles
    tareasAsignadas: TareaModel[] = []; //Lista de tareas disponibles
    tarea: TareaModel = new TareaModel();
    perfilTareasPorPerfil: PerfilTareaDataModel[] = [];
    perfilTarea: PerfilTareaDataModel = new PerfilTareaDataModel(); ç
    eliminarData: EliminarData;

    //Catálogos
    permisos: any[];
    permisosSeleccionados: any[];
    permisosEventosPlanificados: any[];
    permisosEventosPlanificadosSeleccionados: any[];

    //Variables auxiliares
    mostrarEditor: boolean = false;
    mostrarEditorPerfilTareas: boolean = false;
    cols: any[];
    multiSortMeta = [];
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    ui: UIService;

    constructor(
        private router: Router,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private administracionService: AdministracionService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Administración de Perfiles', routerLink: ['administracion/perfiles'] }
        ]);
        this.permisos = [
            { name: 'Lectura', code: 'puedeLeer' },
            { name: 'Crear', code: 'puedeCrear' },
            { name: 'Modificar', code: 'puedeEscribir' },
            { name: 'Borrado', code: 'puedeBorrar' },
            { name: 'Aprobar', code: 'puedeAprobar' },
        ];
        this.permisosEventosPlanificados = [
            { name: 'Importar archivo con lugares/recintos', code: 'puedeImportarArchivo' },
            { name: 'Asignar responsable de lugar/recinto', code: 'puedeAsignarResponsable' },
            { name: 'Cargar incidencia de lugar/recinto', code: 'puedeCargarIncidencia' },
        ];
        this.cols = [
            { field: 'nombre', header: 'Nombre', visible: true },
            { field: 'descripcion', header: 'Descripción', visible: true },
            { field: 'codigo', header: 'Código', visible: false },
        ];
        this.multiSortMeta.push({ field: 'nombre', order: 1 });
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.perfiles = await this.administracionService.getPerfilesData();
        this.cargandoDataInit = false;
    }

    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.mostrarEditorPerfilTareas = false;
        this.permisosSeleccionados = [];
        this.permisosEventosPlanificadosSeleccionados = [];
        this.tareasAsignadas = [];
        this.perfilesSeleccionados = [];
        this.tarea = new TareaModel();
        this.perfil = new PerfilModel();
    }

    nuevoPerfil(): void {
        this.resetVariables();
        this.mostrarEditor = true;
    }

    editarPerfil(perfilModel: PerfilModel): void {
        this.resetVariables();
        this.administracionService.getPerfil(perfilModel.uuid).subscribe(data => {
            this.perfil = data;
            this.mostrarEditor = true;
        });
    }

    formPrincipalCompleto() {
        return true;
    }

    guardarPerfil(): void {
        this.ui.limpiarMessages();
        if (!this.formPrincipalCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            this.administracionService.guardarPerfil(this.perfil).subscribe(
                async (data) => {
                    this.perfil = data;
                    this.perfiles = await this.administracionService.getPerfilesData();
                    this.ui.mostrarMensaje("success", `Actualización del perfil ${this.perfil.name} se realizó con éxito.`);
                    this.mostrarEditor = false;
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    confirmarBorrarPerfil(perfil: PerfilModel): void {
        this.resetVariables();
        if (perfil.name === 'ADMINISTRADOR' || perfil.name === 'USUARIO') {
            this.ui.mostrarMensaje("warn", "No es posible borrar el perfil " + perfil.name + ", debido a que es parte de la configuración del sistema.");
        } else {
            this.confirmationService.confirm({
                message: "¿Está seguro de eliminar el perfil <strong>" + perfil.name + "</strong>?. No será posible recuperar la información.",
                accept: () => {
                    this.borrarPerfil(perfil);
                },
            });
        }
    }

    borrarPerfil(perfil: PerfilModel): void {
        this.administracionService.borrarPerfil(perfil.uuid).subscribe(
            async (data) => {
                this.perfiles = await this.administracionService.getPerfilesData();
                this.ui.mostrarMensaje("success", `El perfil ${perfil.name} ha sido eliminado con éxito.`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    confirmarBorrarSeleccionados() {
        this.ui.limpiarMessages();
        this.confirmationService.confirm({
            message: "¿Está seguro de eliminar los perfiles seleccionados?. No será posible recuperar la información.",
            accept: () => {
                let perfilesPorBorrar: PerfilModel[] = this.perfilesSeleccionados;
                if (perfilesPorBorrar.find((item) => item.name === 'ADMINISTRADOR')
                    || perfilesPorBorrar.find((item) => item.name === 'USUARIO')) {
                    this.ui.mostrarMensaje("warn", "No fue posible borrar alguno de los perfiles seleccionados, debido a que son parte de la configuración del sistema.");
                    this.perfilesSeleccionados = perfilesPorBorrar.filter((val) => val.name != 'ADMINISTRADOR' && val.name != 'USUARIO');
                }
                this.borrarPerfiles();
            },
        });
    }

    borrarPerfiles() {
        this.eliminarData = new EliminarData();
        if (this.perfilesSeleccionados && this.perfilesSeleccionados.length) {
            this.eliminarData.uuids = this.perfilesSeleccionados.map(function(obj) {
                return obj['uuid'];
            });
            this.administracionService.borrarPerfiles(this.eliminarData).subscribe(
                async (data) => {
                    this.perfiles = await this.administracionService.getPerfilesData();
                    this.perfilesSeleccionados = [];
                    this.ui.mostrarMensaje("success", `Los perfiles seleccionados han sido eliminados con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        } else {
            this.ui.mostrarMensaje("warn", `No se han seleccionado perfiles para su eliminación.`);
        }
    }

    /**
    * Editar usuario perfil tareas.
    */
    async editarPerfilTareas(perfilModel: PerfilModel): Promise<void> {
        this.resetVariables();
        this.perfil = perfilModel;
        //Cargar perfilTareas
        this.perfilTareasPorPerfil = await this.administracionService.getPerfilTareaPorPerfilData(this.perfil.id);
        //Cargar la lista de tareas del perfil
        this.tareasAsignadas = await this.administracionService.getPerfilTareasData(this.perfil.id);
        //Cargar sus permisos
        if (this.tareasAsignadas && this.tareasAsignadas.length) {
            this.tareasAsignadas.forEach((element) => {
                this.perfilTarea = this.perfilTareasPorPerfil.find((item) => item.tareaId === element.id);
                if (this.perfilTarea && this.perfilTarea) {
                    element.puedeLeer = this.perfilTarea.puedeLeer;
                    element.puedeCrear = this.perfilTarea.puedeCrear;
                    element.puedeEscribir = this.perfilTarea.puedeEscribir;
                    element.puedeBorrar = this.perfilTarea.puedeBorrar;
                    element.puedeAprobar = this.perfilTarea.puedeAprobar;

                    element.puedeImportarArchivo = this.perfilTarea.puedeImportarArchivo;
                    element.puedeAsignarResponsable = this.perfilTarea.puedeAsignarResponsable;
                    element.puedeCargarIncidencia = this.perfilTarea.puedeCargarIncidencia;
                }
            });
        }
        //Cargar la lista de tareas disponibles
        let tareasAuxiliar: TareaModel[] = await this.administracionService.getTareasAsignablesData();
        this.tareasNoAsignadas = this.difference(tareasAuxiliar ? tareasAuxiliar : [], this.tareasAsignadas ? this.tareasAsignadas : []);
        this.mostrarEditorPerfilTareas = true;
    }

    confirmarGuardarPerfilTareas(): void {
        this.ui.limpiarMessages();
        this.confirmationService.confirm({
            message: "¿Está seguro de actualizar las <strong> tareas </strong> del perfil <strong>" + this.perfil.name + "</strong>?",
            accept: () => {
                this.guardarPerfilTareas(this.perfil.uuid);
            },
        });
    }

    guardarPerfilTareas(uuid: string): void {
        const data = {
            "uuid": uuid,
            "tareas": this.tareasAsignadas
        };
        this.administracionService.guardarPerfilTareas(data).subscribe(
            (data) => {
                this.ui.mostrarMensaje("success", `Actualización de las tareas del perfil ${this.perfil.name} se realizó con éxito.`);
                this.mostrarEditorPerfilTareas = false;
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }

    /**
    ** Métodos de formulario
    **/
    agregarItemsTarea(event): void {
        this.tarea = new TareaModel();
        if (event && event.items) {
            this.tarea = this.tareasAsignadas.find((item) => item.id === event.items[0]['id']);
            if (this.tarea && this.tarea.id) {
                this.tarea.puedeLeer = true;
                this.tarea.puedeCrear = false;
                this.tarea.puedeEscribir = false;
                this.tarea.puedeBorrar = false;
            }
        }
    }

    cargarTareaPermisos(event): void {
        this.ui.limpiarMessages();
        this.permisosSeleccionados = [];
        this.permisosEventosPlanificadosSeleccionados = [];
        this.tarea = new TareaModel();
        if (event && event.items) {
            //Buscar el perfil tarea relacionado con la tarea seleccionada
            this.tarea = this.tareasAsignadas.find((item) => item.id === event.items[0]['id']);
            if (this.tarea && this.tarea.id) {
                if (this.tarea.puedeLeer) {
                    this.permisosSeleccionados.push(this.permisos.find((item) => item.code === 'puedeLeer'));
                }
                if (this.tarea.puedeCrear) {
                    this.permisosSeleccionados.push(this.permisos.find((item) => item.code === 'puedeCrear'));
                }
                if (this.tarea.puedeEscribir) {
                    this.permisosSeleccionados.push(this.permisos.find((item) => item.code === 'puedeEscribir'));
                }
                if (this.tarea.puedeBorrar) {
                    this.permisosSeleccionados.push(this.permisos.find((item) => item.code === 'puedeBorrar'));
                }
                if (this.tarea.puedeAprobar) {
                    this.permisosSeleccionados.push(this.permisos.find((item) => item.code === 'puedeAprobar'));
                }
                if (this.tarea.puedeImportarArchivo) {
                    this.permisosEventosPlanificadosSeleccionados.push(this.permisosEventosPlanificados.find((item) => item.code === 'puedeImportarArchivo'));
                }
                if (this.tarea.puedeAsignarResponsable) {
                    this.permisosEventosPlanificadosSeleccionados.push(this.permisosEventosPlanificados.find((item) => item.code === 'puedeAsignarResponsable'));
                }
                if (this.tarea.puedeCargarIncidencia) {
                    this.permisosEventosPlanificadosSeleccionados.push(this.permisosEventosPlanificados.find((item) => item.code === 'puedeCargarIncidencia'));
                }
            }
        }
    }

    asignarTareaPermisos(event): void {
        if (this.tarea && this.tarea.tareaId) {
            //Quitar los permisos de la tarea
            this.tarea.puedeLeer = false;
            this.tarea.puedeCrear = false;
            this.tarea.puedeEscribir = false;
            this.tarea.puedeBorrar = false;
            this.tarea.puedeAprobar = false;
            this.tarea.puedeImportarArchivo = false;
            this.tarea.puedeAsignarResponsable = false;
            this.tarea.puedeCargarIncidencia = false;
            if (this.permisosSeleccionados && this.permisosSeleccionados.length) {
                this.permisosSeleccionados.forEach((element) => {
                    if (element.code === 'puedeLeer') {
                        this.tarea.puedeLeer = true;
                    } else if (element.code === 'puedeCrear') {
                        this.tarea.puedeCrear = true;
                    } else if (element.code === 'puedeEscribir') {
                        this.tarea.puedeEscribir = true;
                    } else if (element.code === 'puedeBorrar') {
                        this.tarea.puedeBorrar = true;
                    } else if (element.code === 'puedeAprobar') {
                        this.tarea.puedeAprobar = true;
                    }
                });
            }
            if (this.permisosEventosPlanificadosSeleccionados && this.permisosEventosPlanificadosSeleccionados.length) {
                this.permisosEventosPlanificadosSeleccionados.forEach((element) => {
                    if (element.code === 'puedeImportarArchivo') {
                        this.tarea.puedeImportarArchivo = true;
                    } else if (element.code === 'puedeAsignarResponsable') {
                        this.tarea.puedeAsignarResponsable = true;
                    } else if (element.code === 'puedeCargarIncidencia') {
                        this.tarea.puedeCargarIncidencia = true;
                    }
                });
            }
        }
    }

    limpiarPermisos(event): void {
        this.tarea = new TareaModel();
        this.permisosSeleccionados = [];
        this.permisosEventosPlanificadosSeleccionados = [];
    }

    ///////////////////////////////////////////////////////////////////////////
    //Control de acceso a acciones en pantalla
    // TODO: implementar estos métodos en todas las pantallas
    ///////////////////////////////////////////////////////////////////////////
    puedeEjecutar(accion: string): boolean {
        if (!this.currentUser || !this.currentUser.tareas) { //No tiene esta tarea
            return false;
        }

        const routerLink = this.router.url.replace("/fazil/", "");
        let tarea: TareaModel = new TareaModel;
        tarea = this.currentUser.tareas.find(val => routerLink.startsWith(val.routerLink));

        if (!tarea) { //No tiene esta tarea
            return false;
        }
        if (accion == "lectura") {
            return tarea.puedeLeer;
        } else if (accion == "crear") {
            return tarea.puedeCrear;
        } else if (accion == "escritura") {
            return tarea.puedeEscribir;
        } else if (accion == "borrado") {
            return tarea.puedeBorrar;
        } else if (accion == "aprobar") {
            return tarea.puedeAprobar;
        }
        return false;
    }

    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    getTareasPermisos(routeLink: string): Promise<any> {
        return this.fazilService.getTareasPermisos(routeLink).toPromise();
    }

    difference(arr1: TareaModel[], arr2: TareaModel[]) {
        const result = [];
        var i = 0,
            j = 0;
        var flag = false;

        /* For array 1 */
        for (i = 0; i < arr1.length; i++) {

            /* Reseting the flag and the 
            other array iterator */
            j = 0;
            flag = false
            while (j != arr2.length) {
                if (arr1[i].id == arr2[j].id) {
                    flag = true;
                    break;
                }
                j++;
            }

            /* If value is not present in the 
            second array then push that value 
            to the resultant array */
            if (!flag) {
                result.push(arr1[i]);
            }
        }
        flag = false;

        /* For array 2 */
        for (i = 0; i < arr2.length; i++) {

            /* Reseting the flag and the 
            other array iterator */
            j = 0;
            flag = false
            while (j != arr1.length) {
                if (arr2[i].id == arr1[j].id) {
                    flag = true;
                    break;
                }
                j++;
            }

            /* If value is not present in the
            first array then push that value 
            to the resultant array */
            if (!flag) {
                result.push(arr2[i]);
            }
        }
        return result;
    }

}